import axios from "axios";

const URL = "https://api-aumentosprogresivos-production.up.railway.app/"
const URLDEV = "http://localhost:4000/"

export const axiosInstance = axios.create({
    baseURL: URL
})
